import { PapiDeviation } from '@wix/da-papi-types';
import { createAction } from 'redux-actions';
import { WriterPopupLocalState } from '../../modals/WriterPopup/localState';
import { reduxKey } from '../../modals/WriterPopup/redux/constants';
import { WriterError, WriterPopupType } from '../../modals/WriterPopup/redux/types';

export const setIsWriterDeviationFeatured = createAction(
  `${reduxKey}.SET_IS_FEATURED`,
  (payload: { isFeatured?: boolean }) => payload
);

export const saveWriterDeviation = createAction(
  `${reduxKey}.SAVE`,
  (payload: {
    localState: WriterPopupLocalState;
    type?: WriterPopupType;
    deviation?: PapiDeviation;
    groupId?: number;
    doSchedule?: boolean;
  }) => payload
);

export const saveWriterDeviationFailure = createAction(
  `${reduxKey}.SAVE.FAILURE`,
  (error: WriterError) => ({ error })
);

export const saveWriterDeviationSuccess = createAction(
  `${reduxKey}.SAVE.SUCCESS`,
  (payload: { type: WriterPopupType; deviationId: number }) => payload
);

export const publishWriterDeviation = createAction(
  `${reduxKey}.PUBLISH`,
  (payload: {
    localState: WriterPopupLocalState;
    type?: WriterPopupType;
    deviation?: PapiDeviation;
    groupId?: number;
    refreshAfterSubmit?: boolean;
  }) => payload
);

export const resetWriterPopup = createAction(`${reduxKey}.RESET`, () => ({}));
